import { useMutation, useQuery } from "@tanstack/react-query";
import { MutationBasicaParam, QueryBasicaParam } from "../../Utils/RequisicaoUtilitario";
import { TypeAlunoEResponsavel } from "../../Models/Domain/Pessoa/AlunoEResponsavel";
import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
export function useVincularPorCpfResponsavel({
    onSuccess,
    ...rest
}:MutationBasicaParam<TypeAlunoEResponsavel, AxiosResponse<void>>)
{
    return useMutation({
        ...rest,
        mutationFn : (data) => Axios.post<void>("pessoa/alunoResponsavel/cpf", {
            codAluno : data.aluno.codigo,
            cpf : data.responsavel.pessoa!.cpf
        }),
        onSuccess(data, variables, context) {
            // queryClient.invalidateQueries({ queryKey : ["Pessoa.AlunoResponsavel.Responsavel.ObterAlunosResponsavel"] });
            onSuccess?.(data, variables, context);
        },
    });
}

export function useListarAlunoDoResponsavel({
    select,
    selectAfter,
    ...rest
}:QueryBasicaParam<AxiosResponse<TypeAlunoEResponsavel[]>, TypeAlunoEResponsavel[], {
    selectAfter?:(data:TypeAlunoEResponsavel[]) => TypeAlunoEResponsavel[]
}>) {
    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.AlunoResponsavel.Responsavel.ObterAlunosResponsavel" ],
        queryFn : () => Axios.get<TypeAlunoEResponsavel[]>("pessoa/alunoResponsavel/responsavel"),
        staleTime : 1000 * 60 * 10, // 10 minutos
        select(data) {
            if (select) {
                if (selectAfter)
                    return selectAfter(select(data));
                else
                    return select(data);
            }
            return data.data;
        }
    });
}